import { Card, CardContent } from "@components/common/card"
import { ApprovalCardProps } from "@pma/types"
import { cn } from "@pma/utils/helpers"

export function ApprovalCard({
  label,
  count,
  total,
  icon: Icon,
  gradient,
  iconBg,
  iconColor,
  numberColor,
  badgeClass,
  onClick,
}: ApprovalCardProps) {
  const pct = total > 0 ? Math.round((count / total) * 100) : 0
  return (
    <Card
      className={cn(
        "overflow-hidden border-0 bg-gradient-to-br shadow-md transition-shadow duration-200 hover:shadow-lg",
        onClick && "cursor-pointer",
        gradient,
      )}
      onClick={onClick}
    >
      <CardContent className='flex items-center gap-4 p-5'>
        <div
          className={cn(
            "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl shadow",
            iconBg,
          )}
        >
          <Icon className={cn("h-7 w-7", iconColor)} />
        </div>
        <div className='min-w-0 flex-1'>
          <p className='text-sm font-medium text-muted-foreground'>{label}</p>
          <p className={cn("mt-0.5 text-3xl font-bold tabular-nums leading-none", numberColor)}>
            {count.toLocaleString()}
          </p>
        </div>
        <span className={cn("shrink-0 rounded-full px-2.5 py-1 text-xs font-bold", badgeClass)}>
          {pct}%
        </span>
      </CardContent>
    </Card>
  )
}
